export const ACTIVE_SUBSCRIPTION_STATUSES = ["active", "trialing"];

export function isProUser(profile) {
  if (profile?.subscription) {
    return ACTIVE_SUBSCRIPTION_STATUSES.includes(profile.subscription.status);
  }
  return profile?.isPro === true || profile?.hasUnlimitedGarage === true;
}

export function getBuildLimit(profile) {
  return isProUser(profile) ? Infinity : 1;
}

export function canCreateBuild(profile, buildCount) {
  return buildCount < getBuildLimit(profile);
}
